import React, { useEffect, useState } from 'react'
import tw from 'twin.macro'
import { Dialog } from '@headlessui/react'
import { Global } from '@emotion/react'
import { navigate } from 'gatsby'
import { Button } from './styles'

const UPSELL_CONFIG = {
	'EON 100': {
		image:
			'https://images.ctfassets.net/ftcnv5up9dxv/7hjr3tsOP5t9AVKMtIG1E2/ffe2451f1d641d0ad1d2886d37c35c98/Eon120dUpsells_2000x2000.jpg',
		alt: 'Dolphin EON120d',
		continueLabel: 'Continue with EON 100 purchase',
		upgradePath: '/product/dolphin-eon-120d-upgrade-bonus-pack/',
	},
	'S 1000': {
		image:
			'https://images.ctfassets.net/ftcnv5up9dxv/2jMUeaAAkoqyZArfKyhlEt/ed2f4b9c77f68192c10814c7045e987b/S2000Upsells_2000x2000.jpg',
		alt: 'Dolphin S 2000',
		continueLabel: 'Continue with S1000 purchase',
		upgradePath: '/product/dolphin-s-2000-upgrade-bonus-pack/',
	},
	'M 550': {
		image:
			'https://images.ctfassets.net/ftcnv5up9dxv/20gPE80u97eADYX43RQbqi/3b52d720e7c7610770e4e2299b38ea73/M600Upsells_2000x2000.jpg',
		alt: 'Dolphin M 600',
		continueLabel: 'Continue with M550 purchase',
		upgradePath: '/product/dolphin-m-600-upgrade-bonus-pack/',
	},
}

export const hasUpsell = model => Boolean(model && UPSELL_CONFIG[model])

/**
 * Shared upsell popup for EON 100, S 1000 and M 550.
 *
 * model:      the product model that triggered the popup
 * open:       whether the popup is visible
 * onClose:    close the popup
 * onContinue: add the original product to the cart (the caller owns that logic)
 */
const UpsellDialog = ({ model, open, onClose, onContinue }) => {
	const [headerOffset, setHeaderOffset] = useState(0)

	// This is to center the dialog starting where the header ends
	useEffect(() => {
		if (!open) return
		const measure = () => {
			const bar = document.getElementById('main-menu-bar')
			setHeaderOffset(bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0)
		}
		measure()
		window.addEventListener('resize', measure)
		return () => window.removeEventListener('resize', measure)
	}, [open])

	const config = UPSELL_CONFIG[model]
	if (!config) return null

	return (
		<>
			{open && (
				<Global
					styles={{
						html: {
							scrollbarGutter: 'stable',
							paddingRight: '0 !important',
						},
					}}
				/>
			)}
			<Dialog
				open={open}
				onClose={onClose}
				tw="fixed z-10 inset-0 overflow-y-auto"
			>
				<div
					tw="flex items-center justify-center min-h-screen"
					style={{ paddingTop: headerOffset, boxSizing: 'border-box' }}
				>
					<Dialog.Overlay tw="fixed inset-0 bg-black opacity-50" />
					<div tw="relative rounded-lg overflow-hidden mx-6 w-full max-w-md">
						<img
							src={config.image}
							alt={config.alt}
							tw="w-full h-full object-cover"
						/>
						<div tw="absolute bottom-6 left-0 right-0 grid grid-cols-2 gap-6 px-4">
							<div tw="flex justify-center">
								<Button
									onClick={onContinue}
									tw="bg-white hover:bg-yellow-50 hover:text-gray-700 px-0 text-[7px] sm:text-[10px] font-bold"
								>
									{config.continueLabel}
								</Button>
							</div>
							<div tw="flex justify-center">
								<Button
									onClick={() => {
										onClose()
										navigate(config.upgradePath)
									}}
									tw="text-[12px] sm:text-[14px] font-bold"
								>
									Upgrade Now
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Dialog>
		</>
	)
}

export default UpsellDialog